module.exports = __webpack_public_path__ + "images/languagec52c97ab97fa232afa94534aafc481b5.svg";